import React from "react";

//  EMPTY SPACE
const CutisEvents = () => {
  return (
    <video width="300" height="200" controls="false" autoplay="autoplay">
      <source
        src="http://digikit.in/cutis-files/watercolor.mp4"
        type="video/mp4"
      />
    </video>
  );
};
export default CutisEvents;
